import axios, { type AxiosInstance } from 'axios';
import { AUTH_DEVICE_KEY, AUTH_SESSION_KEY, AUTH_CARD_KEY } from './storage-keys';
import { detectDeviceId } from './device-id';

const baseURL = import.meta.env.VITE_API_BASE ?? '';

/**
 * 统一的 HTTP 客户端。
 * 只负责：拼 baseURL、注入设备与会话头、把 401 抛给上层。
 * 业务逻辑一律不放这里。
 */
export const http: AxiosInstance = axios.create({
  baseURL,
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
});

http.interceptors.request.use((config) => {
  config.headers.set('X-Device-ID', localStorage.getItem(AUTH_DEVICE_KEY) ?? detectDeviceId());
  config.headers.set('X-Card-Key', localStorage.getItem(AUTH_CARD_KEY) ?? '');
  config.headers.set('X-Session-Token', localStorage.getItem(AUTH_SESSION_KEY) ?? '');
  config.headers.set('X-Client-Version', 'v0.1.0');
  return config;
});

http.interceptors.response.use(
  (response) => {
    const rotated = response.headers['x-new-session-token'];
    if (typeof rotated === 'string' && rotated) {
      localStorage.setItem(AUTH_SESSION_KEY, rotated);
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      window.dispatchEvent(new CustomEvent('luogen:auth-required'));
    }
    return Promise.reject(error);
  },
);
